window.initSwiper = function() {

    window.swiper = [];
    $('.swiper-container').each(function(index) {

        var $el = $(this);

        window.swiper[index] = $el.swiper({
            speed: 400,
            pagination: $el.find('.swiper-pagination')[0],
            prevButton: $el.find('.swiper-button-prev')[0],
            nextButton: $el.find('.swiper-button-next')[0],
            paginationClickable: true,
            autoplay: 4000,
            autoplayDisableOnInteraction: true,
            simulateTouch: false,
            loop: true
        });

        $el.find('.prev-slide').on('click', function() {
            window.swiper[index].slidePrev();
        });

        $el.find('.next-slide').on('click', function() {
            window.swiper[index].slideNext();
        });

        positionSwipperBullets($el);
    });

}

window.positionSwipperBullets = function(container) {

    if ($(container).find('.swiper-pagination').length > 0) {

        $(container).find('.swiper-pagination').hide();

        var rightWidth = Number($(container).find('.head .head-inner').css('marginRight').replace('px', '')) + Number($(container).find('.head .head-inner').css('paddingRight').replace('px', ''));
        $(container).find('.swiper-pagination').css('right', String(rightWidth) + 'px');

        $(container).find('.swiper-pagination').show();

    }

}

window.updateSwipers = function() {

    window.swiper.forEach(function(swiperInstance) {

        swiperInstance.update();
        swiperInstance.slideTo();
        swiperInstance.startAutoplay();

    });

}